<template>
  <el-row>
    <el-col :span="24">
      <el-col :span="24">
        <el-col :span="6" style="padding-left: 30px;">
          <el-form label-width="80px" class="demo-form-inline">
            <el-form-item label="关键词：">
              <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入机器编码..."></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="18">
          <el-form>
            <el-form-item label="车间：">
              <el-select v-model="chejian" placeholder="请选择车间">
                <el-option label="所有车间" value="0"></el-option>
                <el-option label="未分组" value="-1"></el-option>
                <el-option
                  v-for="(item,index) in chejianlist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>

         
      </el-col>
      <el-col :span="24" style="background:rgba(0,217,255,.15);padding:10px; ">
        <el-row>
          <el-col :span="24">
            <el-table :data="marchinelist" style="width: 100%" border>
              <el-table-column fixed prop="img" label="机台照片" min-width="120">
                <template slot-scope="scope">
                  <img
                    :src="getImgPath(scope.row.img)"
                    width="100"
                    height="60"
                    class="head_pic"
                  />
                </template>
              </el-table-column>
              <el-table-column fixed prop="no" label="机台编号" min-width="100"></el-table-column>

              <el-table-column prop="pinpai" label="机台品牌" min-width="100"></el-table-column>

              <el-table-column prop="xinghao" label="机台型号" min-width="120"></el-table-column>
              <el-table-column prop="imei" label="IMEI" min-width="200"></el-table-column>
              <el-table-column prop="depname" label="所属车间" min-width="120"></el-table-column>
              <el-table-column prop="order" label="排序" min-width="120"></el-table-column>
              <el-table-column prop="caozuo" label="操作" min-width="200">
                <template slot-scope="scope">
                  <el-button @click="editmarchinebtn(scope.row)" type="warning" size="small">编辑</el-button>
                  <el-button @click="setfzmarchinebtn(scope.row)" type="primary" size="small">阀值设置</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col style="margin-top:10px;text-align:center;">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="10"
              :current-page.sync="currentPage1"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-col>

    <el-dialog
      title
      :visible.sync="dialogMarchineVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <el-row style="    margin-top: -40px;">
        <el-col :span="24" class="stoptitle">编辑机台信息</el-col>
        <el-col :span="24" style="margin-top:10px">
          <el-form
            :model="editMarchineModel"
            :rules="marchineRules"
            ref="editmarchineForm"
            label-width="100px"
          >
            <el-form-item label="IMEI" >
              <el-input v-model="editMarchineModel.imei" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="机台编号" prop="no">
              <el-input v-model="editMarchineModel.no"></el-input>
            </el-form-item>
            <el-form-item label="机台品牌" prop="pinpai">
              <el-input v-model="editMarchineModel.pinpai"></el-input>
            </el-form-item>
            <el-form-item label="机台型号" prop="xinghao">
              <el-input v-model="editMarchineModel.xinghao"></el-input>
            </el-form-item>
            <el-form-item label="机台照片" prop="img">
              <el-upload
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                :multiple="false"
                :limit="1"
                :on-change="imgchange"
                :on-remove="handleRemove"
                ref="upload"
                :class="[hasimg?'zupload':'']"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                  <span class="el-upload-list__item-actions">
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="所属车间" prop="dep">
              <el-select v-model="editMarchineModel.dep" placeholder="请选择车间">
                <el-option
                  v-for="(item,index) in chejianlist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="排序" prop="order">
              <el-input type="number" v-model="editMarchineModel.order"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMarchineVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('editmarchineForm')">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title
      :visible.sync="dialogFazhiVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <el-row style="    margin-top: -40px;">
        <el-col :span="24" class="stoptitle">设置机台阈值</el-col>
        <el-col :span="24" style="margin-top:10px">
           <el-table
            :data="fazhiData"
            stripe
            border
            style="width: 100%"
            height="450">
            <el-table-column
              prop="type"
              label="类型"
              min-width="120">
            </el-table-column>
            <el-table-column
              prop="mbz"
              label="目标值"
              width="100">
            </el-table-column>
            <el-table-column
              prop="sx"
              label="上限"
              width="100">
            </el-table-column>
            <el-table-column
              prop="xx"
              label="下限"
              width="100">
            </el-table-column>
            <el-table-column
              prop="dw"
              label="比较单位"
              width="100">
            </el-table-column>
            <el-table-column
              prop="blp"
              label="是否加入不良品"
              width="120">
            </el-table-column>
            <el-table-column prop="caozuo" label="操作" min-width="100">
                <template slot-scope="scope">
                  <el-button @click="editfazhibtn(scope.row)" type="warning" size="small">编辑</el-button>
                </template>
              </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFazhiVisible = false">关 闭</el-button>
        
      </span>
    </el-dialog>

    <el-dialog
      title
      :visible.sync="dialogEditFazhiVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <el-row style="    margin-top: -40px;">
        <el-col :span="24" class="stoptitle">编辑机台阈值信息</el-col>
        <el-col :span="24" style="margin-top:10px">
          <el-form
            :model="editFazhiModel"
            :rules="marchineRules"
            ref="editmarchinefzForm"
            label-width="100px"
          >
            <el-form-item label="阈值类别" prop="type">
              <span style="font-size: 20px;    color: #000;    font-weight: bold;">{{editFazhiModel.type}}</span>
            </el-form-item>
            <el-form-item label="目标值" prop="mbz">
              <el-input type="number" style="width:150px" v-model="editFazhiModel.mbz"></el-input>
            </el-form-item>
            <el-form-item label="上限" prop="sx">
              <el-input type="number" style="width:150px" v-model="editFazhiModel.sx"></el-input>
            </el-form-item>
            <el-form-item label="下限" prop="xx">
              <el-input type="number" style="width:150px" v-model="editFazhiModel.xx"></el-input>
            </el-form-item>
            <el-form-item label="比较单位" prop="dw">
               <el-radio v-model="editFazhiModel.dw" label="0"    name="dw">数值</el-radio>
              <el-radio v-model="editFazhiModel.dw" label="1"   name="dw">百分比</el-radio>
            </el-form-item>
            <el-form-item label="关联不良品" prop="blp">
              <el-radio v-model="editFazhiModel.blp" label="0"    name="blp">否</el-radio>
              <el-radio v-model="editFazhiModel.blp" label="1"   name="blp">是</el-radio>
            </el-form-item>
             
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEditFazhiVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('editmarchinefzForm')">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { getalldep, getallmarchine, editmarchine,getmarchinefz ,editfz} from "../../api/api";
import { getBaseUrl } from '@/config';
export default {
  data() {
    return {
      keyword: "",
      chejian: "0",
      chejianlist: [],
      marchinelist: [],
      editMarchineModel: {
        id: 0,
        no: "",
        pinpai: "",
        xinghao: "",
        imei: "",
        dep: "",
        img: "",
        order: 0
      },
      marchineRules: {
        no: [{ required: true, message: "请输入设备编号...", trigger: "blur" }]
      },
      dialogMarchineVisible: false,
      dialogImageUrl: "",
      disabled: false,
      hasimg: false,
      total: 0,
      currentPage1: 1,
      editFazhiModel:{
        machineid:0,
        type:'',
        mbz:0,
        sx:0,
        xx:0,
        dw:'',
        blp:'',         
      },
      dialogFazhiVisible:false,
      dialogEditFazhiVisible: false,
      fazhiData:[],
      selectmachineid:0,  //阈值选中的机台
    };
  },
  created() {
    this.getdeps();
    this.getmarchinelist(); //获取对应的数据信息
    
  },
  methods: {
    editmarchinebtn(row) {
      this.editMarchineModel.id = row.id;
      this.editMarchineModel.no = row.no;
      this.editMarchineModel.pinpai = row.pinpai;
      this.editMarchineModel.xinghao = row.xinghao;
      this.editMarchineModel.imei = row.imei;
      this.editMarchineModel.order = row.order;
      if(row.dep !=0)
        this.editMarchineModel.dep = row.dep;

      this.dialogMarchineVisible = true;
    },
    handleCurrentChange() {},
    imgchange(file, filelist) {
      let that = this;
      if (filelist.length == 1) {
        that.hasimg = true;
        that.getBase64(file.raw).then(res => {
          that.editMarchineModel.img = res;
        });
      } else {
        that.hasimg = false;
      }
    },
    handleRemove(file) {
      console.log(file);
      this.$refs.upload.clearFiles();
      this.hasimg = false;
      this.editMarchineModel.img = "";
    },
    getmarchinelist() {
      let that = this;
      getallmarchine({
        keyword: that.keyword,
        depid: that.chejian,
        limit: 10,
        page: that.currentPage1
      }).then(res => {
        that.marchinelist = res.data.list;
        that.total = res.data.count;
      });
    },
    getdeps() {
      let that = this;
      getalldep({}).then(res => {
        that.chejianlist = res.data;
      });
    },
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {
       
          imgResult = reader.result;
          let idx = imgResult.indexOf("base64,");
          imgResult = imgResult.substring(idx + 7);
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (formName == "editmarchineForm") {
          
            editmarchine(this.editMarchineModel).then(res => {
              if (res.state == 0) {
                this.$message({
                  message: "编辑设备成功",
                  type: "success"
                });
                that.dialogMarchineVisible = false;
                that.getmarchinelist();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          }else if(formName == 'editmarchinefzForm'){
         
          editfz(this.editFazhiModel).then(res=>{
         
            if (res.state == 0) {
                this.$message({
                  message: "编辑设备阈值",
                  type: "success"
                });
                that.dialogEditFazhiVisible = false;
                 that.getmarchinefzlist(that.selectmachineid);
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
          })
        }
        }else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    setfzmarchinebtn(row){  //设置繁殖按钮
      this.selectmachineid = row.id;
      this.getmarchinefzlist(row.id);
    },
    editfazhibtn(row){
      this.editFazhiModel.machineid = this.selectmachineid;
      this.editFazhiModel.type = row.type;
      this.editFazhiModel.mbz = row.mbz;
      this.editFazhiModel.sx = row.sx;
      this.editFazhiModel.xx = row.xx;
      this.editFazhiModel.dw = row.dw =="数值"?'0':'1';
      this.editFazhiModel.blp = row.blp=="否"?'0':'1';

      this.dialogEditFazhiVisible = true;
    },
    getmarchinefzlist(marchineid){
      let that = this;
      getmarchinefz({marchineid:marchineid}).then(res=>{
        let d = res.data;
        
        let data = [];
        data.push({
          type:'#1段温度',
          mbz:d.Mbz_Wend1,
          sx:d.Sx_Wend1,
          xx:d.Xx_Wend1,
          blp:d.Blp_Wend1==1?"是":"否",
          dw:d.Dw_Wend1 ==1?"百分比":"数值"
        });

        data.push({
          type:'#2段温度',
          mbz:d.Mbz_Wend2,
          sx:d.Sx_Wend2,
          xx:d.Xx_Wend2,
          blp:d.Blp_Wend2==1?"是":"否",
          dw:d.Dw_Wend2 ==1?"百分比":"数值"
        });

        data.push({
          type:'#3段温度',
          mbz:d.Mbz_Wend3,
          sx:d.Sx_Wend3,
          xx:d.Xx_Wend3,
          blp:d.Blp_Wend3==1?"是":"否",
          dw:d.Dw_Wend3 ==1?"百分比":"数值"
        });

        data.push({
          type:'#4段温度',
          mbz:d.Mbz_Wend4,
          sx:d.Sx_Wend4,
          xx:d.Xx_Wend4,
          blp:d.Blp_Wend4==1?"是":"否",
          dw:d.Dw_Wend4 ==1?"百分比":"数值"
        });
        data.push({
          type:'#5段温度',
          mbz:d.Mbz_Wend5,
          sx:d.Sx_Wend5,
          xx:d.Xx_Wend5,
          blp:d.Blp_Wend5==1?"是":"否",
          dw:d.Dw_Wend5 ==1?"百分比":"数值"
        });
         data.push({
          type:'#6段温度',
          mbz:d.Mbz_Wend6,
          sx:d.Sx_Wend6,
          xx:d.Xx_Wend6,
          blp:d.Blp_Wend6==1?"是":"否",
          dw:d.Dw_Wend6 ==1?"百分比":"数值"
        });
        data.push({
          type:'#7段温度',
          mbz:d.Mbz_Wend7,
          sx:d.Sx_Wend7,
          xx:d.Xx_Wend7,
          blp:d.Blp_Wend7==1?"是":"否",
          dw:d.Dw_Wend7 ==1?"百分比":"数值"
        });
        data.push({
          type:'#8段温度',
          mbz:d.Mbz_Wend8,
          sx:d.Sx_Wend8,
          xx:d.Xx_Wend8,
          blp:d.Blp_Wend8==1?"是":"否",
          dw:d.Dw_Wend8 ==1?"百分比":"数值"
        });
        data.push({
          type:'#9段温度',
          mbz:d.Mbz_Wend9,
          sx:d.Sx_Wend9,
          xx:d.Xx_Wend9,
          blp:d.Blp_Wend9==1?"是":"否",
          dw:d.Dw_Wend9 ==1?"百分比":"数值"
        });
        data.push({
          type:'#10段温度',
          mbz:d.Mbz_Wend10,
          sx:d.Sx_Wend10,
          xx:d.Xx_Wend10,
          blp:d.Blp_Wend10==1?"是":"否",
          dw:d.Dw_Wend10 ==1?"百分比":"数值"
        });
        data.push({
          type:'#11段温度',
          mbz:d.Mbz_Wend11,
          sx:d.Sx_Wend11,
          xx:d.Xx_Wend11,
          blp:d.Blp_Wend11==1?"是":"否",
          dw:d.Dw_Wend11 ==1?"百分比":"数值"
        });
        data.push({
          type:'油温',
          mbz:d.Mbz_Youwen,
          sx:d.Sx_Youwen,
          xx:d.Xx_Youwen,
          blp:d.Blp_Youwen==1?"是":"否",
          dw:d.Dw_Youwen ==1?"百分比":"数值"
        });
        data.push({
          type:'循环时间(秒)',
          mbz:d.Mbz_Xunhuansj,
          sx:d.Sx_Xunhuansj,
          xx:d.Xx_Xunhuansj,
          blp:d.Blp_Xunhuansj==1?"是":"否",
          dw:d.Dw_Xunhuansj ==1?"百分比":"数值"
        });
        data.push({
          type:'射出终点位置(mm)',
          mbz:d.Mbz_Shechuzdwz,
          sx:d.Sx_Shechuzdwz,
          xx:d.Xx_Shechuzdwz,
          blp:d.Blp_Shechuzdwz==1?"是":"否",
          dw:d.Dw_Shechuzdwz ==1?"百分比":"数值"
        });
        data.push({
          type:'射出起点位置(mm)',
          mbz:d.Mbz_Shechuqdwz,
          sx:d.Sx_Shechuqdwz,
          xx:d.Xx_Shechuzdwz,
          blp:d.Blp_Shechuzdwz==1?"是":"否",
          dw:d.Dw_Shechuzdwz ==1?"百分比":"数值"
        });
        data.push({
          type:'保压转换终点位置(mm)',
          mbz:d.Mbz_Baoyzhzdwz,
          sx:d.Sx_Baoyzhzdwz,
          xx:d.Xx_Baoyzhzdwz,
          blp:d.Blp_Baoyzhzdwz==1?"是":"否",
          dw:d.Dw_Baoyzhzdwz ==1?"百分比":"数值"
        });
        data.push({
          type:'保压转换压力1段(par)',
          mbz:d.Mbz_Baoyazhyl1,
          sx:d.Sx_Baoyazhyl1,
          xx:d.Xx_Baoyazhyl1,
          blp:d.Blp_Baoyazhyl1==1?"是":"否",
          dw:d.Dw_Baoyazhyl1 ==1?"百分比":"数值"
        });
        data.push({
          type:'保压转换压力2段(par)',
          mbz:d.Mbz_Baoyazhyl2,
          sx:d.Sx_Baoyazhyl2,
          xx:d.Xx_Baoyazhyl2,
          blp:d.Blp_Baoyazhyl2==1?"是":"否",
          dw:d.Dw_Baoyazhyl2 ==1?"百分比":"数值"
        });
        data.push({
          type:'保压转换压力3段(par)',
          mbz:d.Mbz_Baoyazhyl3,
          sx:d.Sx_Baoyazhyl3,
          xx:d.Xx_Baoyazhyl3,
          blp:d.Blp_Baoyazhyl3==1?"是":"否",
          dw:d.Dw_Baoyazhyl3 ==1?"百分比":"数值"
        });

        that.fazhiData = data;

        that.dialogFazhiVisible = true;
      });
    },
    getImgPath(imgpath){
      return getBaseUrl() + imgpath;
    },
  }
};
</script>

<style  >
.zupload > div.el-upload--picture-card {
  display: none !important;
}
</style>